module.exports = __webpack_public_path__ + "img/Instagram.80de423e.png";